import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PropertyListener } from '@vsolv/dev-kit/rx';
import { ToastService } from '@vsolv/vectors-ui/alert';
import { Warranty } from '@wsphere/warranties/domain';
import { map, ReplaySubject } from 'rxjs';
import { WarrantyWebService } from '../../../warranty/services';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-warranty-custom-fields-card',
  templateUrl: './warranty-custom-fields-card.component.html',
  standalone: false,
})
export class WarrantyCustomFieldsCardComponent {
  constructor(
    private router: Router,
    private warrantySvc: WarrantyWebService,
    private toastSvc: ToastService
  ) {}
  @PropertyListener('warranty') private warranty$ = new ReplaySubject<Warranty.Model>(1);
  @Input() warranty?: Warranty.Model;

  metadataFields$ = this.warranty$.pipe(
    map(warranty => {
      const metadata = this.flattenObject(warranty.metadata ?? {});
      return Object.entries(metadata)
        .map(([key, value]) => ({ name: key, value: value }))
        .sort((a, b) => a.name.localeCompare(b.name));
    })
  );

  private flattenObject(obj: object, parentKey = '', result: Record<string, unknown> = {}) {
    for (const [key, value] of Object.entries(obj)) {
      const newKey = parentKey ? `${parentKey} › ${key}` : key;
      if (value && typeof value === 'object' && !Array.isArray(value)) {
        this.flattenObject(value, newKey, result);
      } else {
        result[newKey] = value;
      }
    }
    return result;
  }
}
